/*
# Generated Name display subview
*/

var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['backbone', 'template/document-entry/generated-name.htm'], function(Backbone, generatedNameTemplate) {
  var GeneratedNameView;
  return GeneratedNameView = (function(_super) {

    __extends(GeneratedNameView, _super);

    function GeneratedNameView() {
      GeneratedNameView.__super__.constructor.apply(this, arguments);
    }

    GeneratedNameView.prototype.className = 'document-generated-name-wrapper';

    GeneratedNameView.prototype.template = generatedNameTemplate;

    GeneratedNameView.prototype.initialize = function() {
      this.model.on('change:file', this.render, this);
      return this.render();
    };

    GeneratedNameView.prototype.render = function() {
      return this.$el.html(_.template(this.template, this.model.toJSON()));
    };

    return GeneratedNameView;

  })(Backbone.View);
});
